import initialState from "./defaults/brandRatingSearch";

export default {
  model: "brandRatingSearch",
  initialState,
  endpoint: "/search-brand-ratings",
};
